// // // assets
// // import { FileFilled } from '@ant-design/icons';

// // // icons
// // const icons = {
// //   FileFilled
// // };

// // // ==============================|| MENU ITEMS - USER MASTER ||============================== //

// // const documents= {
// //   id: 'documents',
// //   title: 'Documents',
// //   type: 'group',
// //   children: [
// //     {
// //       id: 'handbook',
// //       title: 'Handbook',
// //       type: 'item',
// //       url: '/handbook',
// //       icon: icons.FileFilled,
// //       breadcrumbs: false
// //     }
// //   ]
// // };

// // export default documents;





// // assets
// import { FileFilled } from '@ant-design/icons';

// const icons = {
//   FileFilled
// };

// const documents = (roleID) => {
//   return roleID == 1
//     ? {
//         id: 'documents',
//         title: 'Documents',
//         type: 'group',
//         children: [
//           { id: 'handbook', title: 'Handbook', type: 'item', url: '/handbook', icon: icons.FileFilled, breadcrumbs: false }
//         ]
//       }
//     : {
//         id: 'documents',
//         title: '',
//         type: 'group',
//         children: []
//       };
// };

// export default documents;


// // assets
// import { FileFilled } from '@ant-design/icons';

// // icons
// const icons = {
//   FileFilled
// };

// // ==============================|| MENU ITEMS - USER MASTER ||============================== //

// const documents= {
//   id: 'documents',
//   title: 'Documents',
//   type: 'collapse',
//   icon: icons.FileFilled,
//   children: [
//     {
//       id: 'handbook',
//       title: 'Gallery',
//       type: 'item',
//       url: '/handbook',
//       icon: icons.FileFilled,
//       breadcrumbs: false
//     }
//   ]
// };

// export default documents;




import { FileFilled } from '@ant-design/icons';

const icons = { FileFilled };
const roles = [0,1,2];

const documents = {
  id: 'documents',
  title: 'Documents',
  type: 'collapse',
  icon: icons.FileFilled,
  roles,
  children: [
    {
      id: 'handbook',
      title: 'Gallery',
      type: 'item',
      url: '/handbook',
      icon: icons.FileFilled,
      breadcrumbs: false,
      roles
    }
  ]
};

export default documents;
